export class WebViewScreenModel {
    /** 開く url */
    url: string | null = null;
    /** タイトル */
    title: string | null = null;
}
